/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.TEXT = function () {

    this.resourceKey = 'Survey.Sidebar.SingleRow';
    this.jsonType = 'TEXT';

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);

};